import PropTypes from 'prop-types';
import Button from '../Button';
import css from './BlurbToAction.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var BlurbToAction = function BlurbToAction(_ref) {
  var blurb = _ref.blurb,
      cta = _ref.cta,
      onClickCta = _ref.onClickCta;
  return /*#__PURE__*/_jsxs("section", {
    className: css.root,
    children: [/*#__PURE__*/_jsx("h1", {
      className: css.blurb,
      dangerouslySetInnerHTML: {
        __html: blurb
      }
    }), /*#__PURE__*/_jsx(Button, {
      medium: true,
      className: css.cta,
      onClick: onClickCta,
      children: cta
    })]
  });
};

BlurbToAction.defaultProps = {
  onClickCta: function onClickCta() {}
};
BlurbToAction.propTypes = {
  blurb: PropTypes.string.isRequired,
  cta: PropTypes.string.isRequired,
  onClickCta: PropTypes.func
};
export default BlurbToAction;